import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgWarning = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={svgRef}
    {...props}
  >
    <path
      fill="#FA0"
      fillRule="evenodd"
      d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm1-5.003a1.013 1.013 0 01-.288.712A.984.984 0 018 12a.99.99 0 01-.712-.291A1.013 1.013 0 017 10.997a1.006 1.006 0 01.288-.712.96.96 0 01.32-.21C7.73 10.025 7.86 10 8 10c.143 0 .275.025.396.075a.968.968 0 01.527.527c.051.121.077.253.077.395zM8.75 8.25a.75.75 0 01-1.5 0v-4.5a.75.75 0 011.5 0v4.5z"
      clipRule="evenodd"
    />
  </svg>
));
SvgWarning.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgWarning;
